<template>
  <router-view />
  <div v-if="isCookieModalVisible" class="cookie-consent-overlay"></div>
  <CookieConsentModal />
</template>

<script>

import axios from 'axios';
import store from "@/store"
import { computed } from 'vue';
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';
import CookieConsentModal from '@/components/CookieConsent/CookieConsentModal.vue';

export default {
  name: 'App',
  components: {
    CookieConsentModal
  },
  setup() {
    const { t, locale } = useI18n()
    const vuexStore = useStore();
    const isCookieModalVisible = computed(() => vuexStore.state.cookieConsent?.isModalVisible ?? false);
    return {
      t,
      locale,
      isCookieModalVisible,
    }
  },
  data() {
    return {
      menu: null,
      status: null
    }
  },
  async mounted() {
    await this.getMenu();
  },
  methods: {
    async getMenu() {
      this.menu = (await axios.post("/api/PegaPortal/GetSystemMenuList", { Type: "Header", SystemType: this.$store.state.systemType })).data;
      store.commit('setMenu', this.menu);
      this.status = (await axios.post("/api/PegaPortal/GetSystemMenuStatus", { Type: "Header", SystemType: this.$store.state.systemType })).data;
      store.commit('setStatus', this.status);
    }
  }
};
</script>